/**
 * 🚦 MODÜL AÇMA/KAPAMA BAYRAKLARI
 *
 * Henüz hazır olmayan modüllerin menü girişlerini tek yerden kapatmak için.
 * Amaç: kullanıcı yarım kalmış bir modüle girip EKSİK İŞLEM yapmasın.
 *
 * Kapatma yalnızca MENÜ GİRİŞLERİNİ etkiler — route'lar açık kalır, yani
 * doğrudan URL ile giren (geliştirici/test) hâlâ erişebilir. Modül hazır
 * olunca bayrağı `true` yapmak yeterlidir, başka hiçbir yeri değiştirmeyin.
 */

/** CRM modülü — 2026-09-13 itibarıyla TEKRAR AÇIK (kullanıcı kararı).
 *  Ağustosta "yarım işlem riski" gerekçesiyle kapatılmıştı. */
export const CRM_AKTIF = true;

/** Bacteria AI — v2 Faz 1 sonrası tekrar AÇIK (2026-08-31).
 *  Çıkarım tabanı düzeltildi (301 → 905 müşteri: Logo satışları da okunuyor) ve
 *  ekranın üstünde canlı sağlık şeridi var — bayat cache / eksik veri artık
 *  sessiz kalmıyor, kullanıcı neye baktığını görüyor. */
export const BACTERIA_AKTIF = true;

/** Kapalı modül rozetinde yazacak metin. */
export const KAPALI_ETIKET = 'KULLANILMIYOR';

/** Kapalı modüle tıklanınca gösterilecek mesaj — modül bazlı. */
export const KAPALI_MESAJ =
  'CRM şu anda kullanıma kapalı. Hazır olduğunda açılacak.';

export const BACTERIA_KAPALI_MESAJ =
  'Bacteria AI, yetersiz bilgi sebebiyle bilgi doğruluğu için kapatılmıştır.';
